import { createLightTheme } from '../../utils/createLightTheme';
import { brandTeams } from '../../global/brandColors';
import type { Theme } from '../../types';

export const teamsLightTheme: Theme = createLightTheme(brandTeams);
